import { render } from "./FishDataMaterial.vue?vue&type=template&id=c61cc7f8"
import script from "./FishDataMaterial.vue?vue&type=script&lang=js"
export * from "./FishDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__